import { render, staticRenderFns } from "./Competitor.vue?vue&type=template&id=112725ce&scoped=true&lang=html"
import script from "./Competitor.vue?vue&type=script&lang=js"
export * from "./Competitor.vue?vue&type=script&lang=js"
import style0 from "./Competitor.vue?vue&type=style&index=0&id=112725ce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112725ce",
  null
  
)

export default component.exports